/**
 * Polska typografia — zapobiega "sierotom": pojedyncze wyrazy (a i o u w z) oraz
 * myślnik/półpauza nie mogą zostać na końcu linii. Wstawia twardą spację (NBSP).
 * Stosować do KAŻDEGO polskiego tekstu wyświetlanego w UI.
 */
const NBSP = " ";

export function nbsp(text: string): string {
  if (!text) return text;
  return text
    // twarda spacja PO jednoliterowym wyrazie (a i o u w z) — nie kończy linii
    .replace(/(?<=^|[\s(„"«»])([aiouwzAIOUWZ]) /g, `$1${NBSP}`)
    // twarda spacja PO myślniku/półpauzie ze spacjami — myślnik nie zwisa na końcu
    .replace(/([—–]) /g, `$1${NBSP}`);
}
